const en = {
  common: {
    language: 'Language',
    romanian: 'Romanian',
    english: 'English',
  },
  navbar: {
    pages: 'Pages',
    notifications: 'Notifications',
    markAllRead: 'Mark all read',
    loadMore: 'Load More',
    hey: 'Hey',
    switchAccount: 'Switch Account',
    noLinkedAccounts: 'No linked accounts',
    linkAnotherAccount: 'Link another account',
    profileSettings: 'Profile Settings',
    changePassword: 'Change Password',
    logout: 'Log out',
    toggleTheme: 'Toggle color theme',
  },
  sidebar: {
    collapse: 'Collapse menu',
    expand: 'Expand menu',
  },
  routes: {
    mainDashboard: 'Main Dashboard',
    orders: 'Orders',
    partialOrders: 'Partial Orders',
    products: 'Products',
    editForm: 'Edit Form',
    createForm: 'Create Form',
    landingPageBuilder: 'Landing Page Builder',
    editProduct: 'Edit Product',
    createProduct: 'Create Product',
    duplicateProduct: 'Duplicate Product',
    team: 'Team',
    roas: 'ROAS',
    calculator: 'Calculator',
    settings: 'Settings',
    changePassword: 'Change Password',
    linkAccount: 'Link Account',
    acceptLinking: 'Accept Linking',
    forbidden: 'Forbidden',
    signIn: 'Sign In',
  },
  signIn: {
    title: 'Sign In',
    subtitle: 'Enter your email and password to sign in!',
    email: 'Email',
    password: 'Password',
    submit: 'Sign In',
    placeholders: {
      email: 'Enter your email',
      password: 'Enter your password',
    },
    errors: {
      failedToLogin: 'Failed to login',
    },
  },
  forbidden: {
    title: 'Access forbidden',
    defaultMessage: "You don't have permission to access this resource.",
    requested: 'Requested',
    goBack: 'Go back',
    goDashboard: 'Go to dashboard',
  },
  changePassword: {
    title: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    submit: 'Change Password',
    placeholders: {
      currentPassword: 'Enter current password',
      newPassword: 'Enter new password',
      confirmNewPassword: 'Confirm new password',
    },
    aria: {
      toggleCurrentPassword: 'Toggle current password visibility',
      toggleNewPassword: 'Toggle new password visibility',
      toggleConfirmPassword: 'Toggle confirm password visibility',
    },
    messages: {
      passwordsDoNotMatch: 'Passwords do not match',
      changedSuccess: 'Password changed successfully!',
      genericError: 'An error occurred',
    },
  },
  linkAccount: {
    premiumRequired: 'You need a premium account to invite others.',
    title: 'Link one of your accounts',
    inviteeEmail: 'Invitee Email',
    sendInvite: 'Send Invite',
    placeholders: {
      email: 'user@example.com',
    },
    messages: {
      failedInvite: 'Failed to send invite',
    },
  },
  acceptLink: {
    linked: 'Linked!',
    failed: 'Failed to accept invite',
    success: 'Success!',
    goDashboard: 'Go to Dashboard',
    oops: 'Oops!',
    home: 'Home',
  },
  settings: {
    tabs: { general: 'General', facebook: 'Facebook', tiktok: 'TikTok' },
    labels: {
      storeUrl: 'WooCommerce Store URL',
      thankYouPage: 'Thank you page (OPTIONAL)',
      consumerKey: 'WooCommerce Consumer Key',
      consumerSecret: 'WooCommerce Consumer Secret',
      apiKey: 'API Key',
      facebookPixel: 'Facebook Pixel ID (OPTIONAL)',
      conversionToken: 'Conversion API Token (OPTIONAL)',
      tiktokPixel: 'TikTok Pixel (OPTIONAL)',
    },
    placeholders: {
      storeUrl: 'Enter store URL',
      consumerKey: 'Enter consumer key',
      consumerSecret: 'Enter consumer secret',
      facebookPixel: 'Enter Facebook Pixel script',
      conversionToken: 'Enter conversion API token',
      tiktokPixel: 'Enter TikTok pixel',
    },
    tooltips: { showApiKey: 'Show API key' },
    aria: {
      showApiKey: 'Show API key',
      addRecipient: 'Add recipient',
      removeRecipient: 'Remove recipient',
    },
    addEmailRecipients: 'Add Email Recipients',
    saveSettings: 'Save Settings',
    toast: {
      saved: 'Settings saved successfully',
      failedSave: 'Failed to save settings',
      syncStarted: 'Orders started to synchronize. You can leave this page',
      failedSync: 'Failed to sync orders',
      maxRecipients: 'Maximum of email recipients is 2',
      recipientsSaved: 'Email recipients saved successfully',
      failedRecipients: 'Failed to save email recipients',
    },
    modal: {
      addRecipients: 'Add Email Recipients',
      email: 'Email',
      enterEmail: 'Enter email',
      saveRecipients: 'Save Recipients',
      cancel: 'Cancel',
    },
  },
  team: {
    createEmployee: 'Create Employee',
    editEmployee: 'Edit Employee',
    update: 'Update',
    save: 'Save',
    cancel: 'Cancel',
    table: { name: 'Name', email: 'Email', permissions: 'Permissions', actions: 'Actions' },
    form: {
      name: 'Name',
      email: 'Email',
      password: 'Password',
      newPasswordOptional: 'New Password (optional)',
      permissions: 'Permissions',
    },
    aria: { editMember: 'edit member', deleteEmployee: 'delete employee' },
    confirm: { deleteEmployee: 'Are you sure you want to delete this employee?' },
    toast: {
      failedFetchEmployees: 'Failed to fetch employees',
      failedFetchPermissions: 'Failed to fetch permissions',
      employeeUpdated: 'Employee updated',
      employeeCreated: 'Employee created',
      saveFailed: 'Save failed',
      somethingWrong: 'Something went wrong',
      employeeDeleted: 'Employee deleted',
      deleteFailed: 'Delete failed',
    },
  },
  products: {
    searchProduct: 'Search Product',
    searchByName: 'Search by name',
    createProduct: 'Create Product',
    openLink: 'Open Product Link',
    noLink: 'No link',
    currencyLei: 'LEI',
    editProduct: 'Edit product',
    duplicateProduct: 'Duplicate product',
    loadingForm: 'Loading form...',
    editForm: 'Edit form',
    previewForm: 'Preview form',
    landingBuilder: 'Landing builder',
    deleteProduct: 'Delete product',
    showing: 'Showing',
    of: 'of',
    deleteConfirmationTitle: 'Delete Confirmation',
    deleteConfirmation: 'Are you sure you want to delete this product?',
    cancel: 'Cancel',
    delete: 'Delete',
    formPreview: 'Form Preview',
    close: 'Close',
    messages: { noForm: 'This product does not have a form' },
    products: 'products',
    table: {
      name: 'Name',
      slug: 'Slug (Unique)',
      productId: 'Product ID',
      link: 'Link',
      options: 'Options',
      actions: 'Actions',
    },
    aria: { productLink: 'Product Link', actions: 'Actions' },
  },
  productForm: {
    description: 'Keep product details, buying options and integrations organized in one flow.',
    setupProgress: 'Setup progress',
    step: 'Step',
    of: 'of',
    previous: 'Previous',
    next: 'Next',
    save: 'Save',
    mode: { duplicate: 'Duplicate product', edit: 'Edit product', create: 'Create product' },
    steps: {
      basics: { title: 'Basics', description: 'Name, IDs and product behavior' },
      options: { title: 'Options', description: 'Prices, quantities and images' },
      advanced: { title: 'Advanced', description: 'Colors and WooCommerce IDs' },
      review: { title: 'Review', description: 'Confirm before saving' },
    },
    messages: {
      duplicated: 'Product duplicated successfully',
      updated: 'Product updated successfully',
      created: 'Product created successfully',
    },
  },
  formEditor: {
    mode: { edit: 'Edit form', create: 'Create form' },
    selected: 'Selected',
    noThemeSelected: 'No theme selected',
    chooseCheckoutLook: 'Choose a checkout look',
    hideThemes: 'Hide themes',
    changeTheme: 'Change theme',
    addField: 'Add Field',
    addUpsell: 'Add Upsell',
    saveForm: 'Save form',
    themePreset: 'Theme Preset',
    pageDescription: 'Configure the customer form, shipping, terms, upsells and checkout theme.',
    themePresetsUnavailable: 'Theme presets are currently unavailable for this form.',
    themePresetsLoadError: 'Theme presets could not be loaded right now.',
    themePresetsEmptyForForm: 'No theme presets were returned for this form.',
    themePresetsEmpty: 'No theme presets are available right now.',
    loadError: 'We could not load this form right now.',
    messages: { updated: 'Form updated successfully', created: 'Form created successfully' },
  },
  landing: {
    pageDescription: 'Edit product content and export Elementor JSON template for WordPress.',
    save: 'Save',
    saveExport: 'Save & Export JSON',
    messages: {
      saved: 'Landing page saved successfully.',
      exported: 'Elementor JSON exported successfully.',
      mediaUploaded: 'Media uploaded successfully.',
    },
  },
  dashboard: {
    startDate: 'Start Date',
    endDate: 'End Date',
    dateRange: 'Date Range',
    ranges: {
      today: 'Today',
      yesterday: 'Yesterday',
      thisWeek: 'This Week',
      lastWeek: 'Last Week',
      thisMonth: 'This Month',
      lastMonth: 'Last Month',
      thisYear: 'This Year',
      lastYear: 'Last Year',
      maximum: 'Maximum',
    },
    period: {
      yesterday: 'yesterday',
      dayBeforeYesterday: 'the day before yesterday',
      lastWeek: 'last week',
      weekBeforeLastWeek: 'the week before last week',
      lastMonth: 'last month',
      monthBeforeLastMonth: 'the month before last month',
      lastYear: 'last year',
      yearBeforeLastYear: 'the year before last year',
    },
    cards: {
      totalSalesOrders: 'Total Sales / Orders',
      totalDelivered: 'Total / Orders Delivered',
      avgOrderValue: 'Average Order Value',
      spend: 'Spend',
      roas: 'ROAS',
      conversionRate: 'Conversion Rate',
      metaTokenExpired: 'Your Meta access token has expired. ROAS data will stop updating until it is replaced.',
    },
    table: {
      productName: 'Product Name',
      totalSales: 'Total Sales',
      totalOrders: 'Total Orders',
      totalUnits: 'Total Units Sold',
      returnRate: 'Return %',
    },
    orders: 'orders',
    upsells: 'Upsells',
  },
  roas: {
    startDate: 'Start Date',
    endDate: 'End Date',
    monthShortcut: 'Month (shortcut)',
    saveAll: 'Save All',
    save: 'Save',
    total: 'Total',
    previous: 'Previous',
    next: 'Next',
    page: 'Page',
    table: { day: 'Day', spend: 'Spend', sales: 'Sales', orders: 'Orders' },
    messages: {
      maxRange: 'Please select a date range of up to 31 days',
      spendSaved: 'Spend saved',
      allSaved: 'All spends saved',
    },
  },
  orders: {
    title: 'Orders',
    delete: 'Delete',
    sync: 'Sync',
    syncing: 'Syncing…',
    syncFailedTooltip: 'Sync failed, click Sync to retry',
    selectedCount: '{{count}} orders selected',
    toggleColumns: 'Toggle columns',
    editOrder: 'Edit Order',
    viewUpsells: 'View upsells',
    deleteConfirmationTitle: 'Delete confirmation',
    deleteConfirmation: 'Are you sure you want to delete this?',
    bulkDeleteConfirmation: 'Are you sure you want to delete {{count}} selected orders? This action cannot be undone.',
    bulkSyncConfirmationTitle: 'Sync confirmation',
    bulkSyncConfirmation: 'Are you sure you want to sync {{count}} selected orders with WooCommerce?',
    filters: {
      startDate: 'Start Date',
      endDate: 'End Date',
      product: 'Product',
      selectProduct: 'Select Product',
      allProducts: 'All Products',
      source: 'Source',
      selectSource: 'Select Source',
      allSources: 'All sources',
      filterSynced: 'Filter Synced',
      allOrders: 'All orders',
      synced: 'Synced',
      notSynced: 'Not Synced',
      riskLevel: 'Risk Level',
      allRiskLevels: 'All risk levels',
      low: 'Low',
      medium: 'Medium',
      high: 'High',
      notScored: 'Not scored',
      search: 'Search',
    },
    table: {
      createdAt: 'Created At',
      actions: 'Actions',
      risk: 'Risk',
      product: 'Product',
      option: 'Option',
      name: 'Name',
      phone: 'Phone',
      county: 'County',
      city: 'City',
      address: 'Address',
      total: 'Total',
      status: 'Status',
      synced: 'Synced',
      source: 'Source',
      upsell: 'Upsell',
    },
    tooltip: {
      deleteSelected: 'Delete selected orders',
      syncSelected: 'Sync selected orders with WooCommerce',
      ipBlocked: 'This IP is blocked',
      phoneFoundInOrders: 'This number is found in your orders',
      times: 'times',
      shortPhone: 'This number has less than 10 digits',
    },
    aria: {
      visibleColumns: 'Visible columns',
      blockUserTooltip: 'Block User Tooltip',
      blockedIpTooltip: 'Blocked IP Tooltip',
      phoneDuplicates: 'Phone Numbers Duplicates',
      invalidPhoneTooltip: 'Invalid phone tooltip',
      viewUpsell: 'view upsell',
      actions: 'Actions',
      removeUpsell: 'Remove upsell',
    },
    form: {
      name: 'Name',
      phone: 'Phone',
      digits: 'digits',
      address: 'Address',
      city: 'City',
      county: 'County',
      postalCode: 'Postal Code',
      postalSuggestions: 'Postal Code Suggestions',
      status: 'Status',
      option: 'Option',
      upsellDetails: 'Upsell Details',
    },
    status: { pending: 'Pending', cancelled: 'Cancelled' },
    editOrderAction: 'Edit order',
    blockIp: 'Block IP',
    deleteOrder: 'Delete order',
    showing: 'Showing',
    from: 'from',
    orders: 'orders',
    phoneAppearsIn: 'This phone number appears in',
    lastOrder: 'Last order',
    noStatusBreakdown: 'No per-status breakdown available.',
    noMorePostalCodes: 'No more codes found for this address',
    loadNextPostalCodes: 'Load next 3 postal codes found',
    loadMore: 'Load more',
    cancel: 'Cancel',
    save: 'Save',
    saveStay: 'Save & Stay',
    messages: {
      deleted: 'Order deleted successfully',
      bulkDeleted: 'Orders deleted successfully',
      bulkDeleteFailed: "Orders couldn't be deleted successfully",
      bulkSynced: 'Orders synced successfully',
      bulkSyncFailed: "Orders couldn't be synced successfully",
      synced: 'Order synced successfully',
      syncFailed: "Order couldn't be synced successfully",
      alreadySyncing: 'Already syncing, please wait for it to finish',
      allSelectedSyncing: 'Selected orders are already syncing',
      updated: 'Order updated successfully',
      phoneDigits: 'The phone number should have at least 10 digits!',
      ipBlocked: 'has been blocked',
    },
  },
  partials: {
    allProducts: 'All products',
    showing: 'Showing',
    of: 'of',
    orders: 'orders',
    editPartialOrder: 'Edit Partial Order',
    deleteConfirmationTitle: 'Delete Confirmation',
    deleteConfirmation: 'Are you sure you want to delete this partial?',
    bulkDeleteConfirmation: 'Are you sure you want to delete {{count}} selected partials? This action cannot be undone.',
    selectedCount: '{{count}} partials selected',
    filters: {
      product: 'Product',
      selectProduct: 'Select Product',
      search: 'Search',
      submitAttempt: 'Submit Attempt',
      all: 'All',
      attempted: 'Attempted',
      notAttempted: 'Not attempted',
      excludeProducts: 'Exclude products from list',
    },
    table: {
      createdAt: 'Created At',
      actions: 'Actions',
      product: 'Product',
      option: 'Option',
      name: 'Name',
      phone: 'Phone',
      county: 'County',
      city: 'City',
      address: 'Address',
      shipment: 'Shipment',
      submitAttempt: 'Submit Attempt',
      phoneExists: 'Phone Exists',
      terms: 'Terms',
      calls: 'Number Of Calls',
    },
    tooltip: {
      deleteSelected: 'Delete selected partials',
      shortPhone: 'This number has less than 10 digits',
      attempted: 'Attempted to submit',
      notAttempted: 'Did not submit',
      phoneExists: 'Phone number exists in orders',
      termsAccepted: 'Terms Accepted',
      termsNotAccepted: 'Terms Not Accepted',
    },
    aria: {
      shortPhone: 'Phone number is too short',
      actions: 'Actions',
      removeUpsell: 'Remove upsell',
    },
    form: {
      name: 'Name',
      phone: 'Phone',
      address: 'Address',
      city: 'City',
      county: 'County',
      option: 'Option',
      colors: 'Colors',
      selectColor: 'Select color',
      upsells: 'Upsells',
    },
    delete: 'Delete',
    editPartial: 'Edit partial',
    confirmOrder: 'Confirm order',
    addCall: 'Add call',
    deletePartial: 'Delete partial',
    cancel: 'Cancel',
    save: 'Save',
    messages: {
      deletedSelected: 'Partials deleted!',
      callAdded: 'Call added!',
      deleted: 'Partial deleted!',
      orderConfirmed: 'Order confirmed!',
      updated: 'Partial updated successfully!',
      phoneDigits: 'The phone number should have at least 10 digits!',
    },
  },
}

export default en
